module.exports = __webpack_public_path__ + "static/media/page07_man_woman.7c193dc0.gif";